"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vitalwareNotAvailable = void 0;
exports.vitalwareNotAvailable = {
    caseUid: "83ffb36c-997b-47a6-8253-25af87a626d7",
    isChargeable: true,
    tenantId: {
        uuid: "b5f41b81-a75c-40cc-a8cb-5cad2aff35cb"
    },
    healthSystemTenantId: {
        uuid: "5a47d569-c0fe-4293-8bdc-56b21f6094bc"
    },
    guid: {
        uuid: "bfc6850c-f1bb-4a37-b85a-f5e7a211da91"
    },
    serviceLine: "IPC",
    caseType: "PLAYGROUND",
    gender: "male",
    dateOfBirth: "1983-02-18",
    age: 39,
    hl7InsurancePayerId: "103022",
    hl7InsurancePlanId: "103022003",
    cmxInsurancePayerId: null,
    status: "IN_PROGRESS",
    qaStatus: null,
    sharedDiagnosisCodes: [],
    errors: [
        {
            field: "invoices",
            message_key: "invoice.claims_edit.invalid",
            message: "This case has been sent to coder because the claim edit workflow is temporarily unable to handle the request.",
            source: "CLAIMS_EDIT"
        }
    ],
    invoices: [
        {
            type: "clinical",
            guid: "fa247be3-b5b2-430e-965a-885e61043f14",
            date_of_service: null,
            datetime_of_service: null,
            department_code: null,
            department: {
                name: null,
                code: null
            },
            patient_type: null,
            billing_location: null,
            billing_area: null,
            fee_schedule: null,
            division: null,
            facility: null,
            filler_number: {
                number: null,
                issuer: null,
                type: null
            },
            billing_provider_name: null,
            billing_provider_number: {
                issuer: "EPIC",
                number: "3243432",
                type: "IDNO"
            },
            ordering_provider_name: null,
            ordering_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            referring_provider_name: null,
            referring_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            performing_provider_name: null,
            performing_provider_number: {
                number: null,
                issuer: "EPIC",
                type: "IDNO"
            },
            transactions: [
                {
                    guid: "478ac73f-022e-4275-be65-6c08cfb7dcfc",
                    sequence_number: 1,
                    source_transaction_id: null,
                    deleted: false,
                    technical_code: null,
                    procedure: {
                        procedure_code: "88305",
                        units: 2,
                        sequence_number: 1,
                        custom_cpt: false,
                        evidence: [],
                        additionalProperties: {
                            id: 12289
                        }
                    },
                    mapped_procedure: {
                        procedure_code: "88305",
                        units: 2,
                        sequence_number: 1,
                        custom_cpt: false,
                        active: true,
                        evidence: [],
                        additionalProperties: {
                            id: 12289
                        }
                    },
                    modifiers: [],
                    diagnoses: [
                        {
                            diagnosis_code: "C79.31",
                            sequence_number: 1,
                            evidence: [],
                            additionalProperties: {
                                id: 10573
                            },
                            shared: false,
                            active: true
                        },
                        {
                            diagnosis_code: "J91.0",
                            sequence_number: 2,
                            evidence: [],
                            additionalProperties: {
                                id: 11106
                            },
                            shared: false,
                            active: true
                        }
                    ],
                    fee_schedule: null,
                    place_of_service: null
                }
            ],
            deleted: false,
            health_plan_id: null,
            billing_provider_type: null,
            ordering_provider_type: null,
            referring_provider_type: null,
            performing_provider_type: null
        }
    ],
    documentImprovements: [],
    cancelled: false,
    autoCancelled: false
};
//# sourceMappingURL=vitalware-not-available.js.map